import { CssBaseline, ThemeProvider } from '@mui/material';
import { v4 } from '@packages/themes/v4';
import type { ReactNode } from 'react';

import { v3 } from '@/styles/theme';

export interface AppThemeProviderProps {
  useV4Theme: boolean;
  children: ReactNode;
}

export default function AppThemeProvider({
  useV4Theme,
  children,
}: AppThemeProviderProps) {
  return (
    <ThemeProvider theme={useV4Theme ? v4 : v3}>
      <CssBaseline {...(useV4Theme ? { enableColorScheme: true } : {})} />
      {children}
    </ThemeProvider>
  );
}
